export default __webpack_public_path__ + "static/arcade-soundtrack-01-6f4e0684914b1706a9c04ab58dde332a.mp3";